import { Link } from 'react-router-dom'
import { Camera, Video, Mic, Lightbulb, Shield, Package, Users, ArrowRight, Heart, Clock, Zap } from 'lucide-react'
import { getImageUrl } from '../utils/apiUrl'
import packageJson from '../../package.json'
import backgroudImage from '../assets/backgroud.jpeg'
import BannerSlider from '../components/BannerSlider'

const Home = () => {
  const categories = [
    {
      name: 'Images',
      description: 'Caméras, objectifs et accessoires professionnels',
      icon: Camera,
      image: '/images/Arri.jpeg',
      href: '/catalogue-materiels?parent_category=image'
    },
    {
      name: 'Éclairage',
      description: 'Projecteurs et diffuseurs',
      icon: Lightbulb,
      image: '/images/category-lumiere.png',
      href: '/catalogue-materiels?parent_category=lumiere'
    },
    {
      name: 'Machinerie',
      description: 'Support et accessoires',
      icon: Mic,
      image: '/images/category-machinerie.jpg',
      href: '/catalogue-materiels?parent_category=machinerie'
    },
    {
      name: 'Énergie',
      description: 'Générateurs et alimentation',
      icon: Lightbulb,
      image: '/images/category-energie.webp',
      href: '/catalogue-materiels?parent_category=energie'
    },
    {
      name: 'Régie',
      description: 'Équipements de régie et contrôle',
      icon: Video,
      image: '/images/category-regie.jpg',
      href: '/catalogue-materiels?parent_category=la-regie'
    },
    {
      name: 'Audio',
      description: 'Équipements audio professionnels',
      icon: Mic,
      image: '/images/category-Audio.png',
      href: '/catalogue-materiels?parent_category=audio'
    }
  ]

  const features = [
    {
      icon: Shield,
      title: 'Matériel professionnel',
      description: 'Équipements de dernière génération pour tous vos projets'
    },
    {
      icon: Package,
      title: 'Référence en stock',
      description: 'Des centaines d\'équipement en stock'
    },
    {
      icon: Users,
      title: 'Support expert',
      description: 'Conseils techniques et assistance personnalisée'
    }
  ]

  return (
    <div className="min-h-screen">
      {/* Bannière principale */}
      <div className="w-full">
        <BannerSlider />
      </div>

      {/* Categories Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="text-gradient">Catalogue</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Découvrez notre gamme complète de matériel professionnel pour vos tournages de fiction, pub, clip, documentaire...
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((category, index) => (
              <div key={category.name} className="group">
                <Link
                  to={category.href}
                  className="block bg-white rounded-xl transition-all duration-300 overflow-hidden"
                >
                  {/* Image avec effet de zoom */}
                  <div className="relative h-72 overflow-hidden">
                    <img 
                      src={import.meta.env.DEV ? 
                        `http://localhost:3002${category.image}?v=${packageJson.version}` : 
                        `${getImageUrl(category.image)}?v=${packageJson.version}`
                      }
                      alt={category.name}
                      className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ${
                        category.name === 'Éclairage' || category.name === 'Images' ? 'object-top' : ''
                      }`}
                      style={category.name === 'Éclairage' || category.name === 'Images' ? 
                        { 
                          objectPosition: category.name === 'Images' ? 'center 30%' : 'center 20%'
                        } : category.name === 'Énergie' || category.name === 'Régie' ?
                        {
                          objectPosition: 'center 70%'
                        } : category.name === 'Machinerie' ?
                        {
                          objectPosition: 'center 60%'
                        } : category.name === 'Audio' ?
                        {
                          objectPosition: 'center 70%'
                        } : {}}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="absolute inset-0 bg-gray-100 flex items-center justify-center hidden">
                      <category.icon className="h-16 w-16 text-gray-400" />
                    </div>
                    
                    {/* Overlay gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  </div>
                  
                  {/* Contenu texte */}
                  <div className="p-6">
                    <h3 
                      className="text-xl font-bold text-gray-900 mb-1 transition-colors"
                      style={{ 
                        color: '#1f2937',
                        '--hover-color': '#ff9a06'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#ff9a06'}
                      onMouseLeave={(e) => e.target.style.color = '#1f2937'}
                    >
                      {category.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      {category.description}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Consommables */}
      <section className="section-padding bg-gradient-to-br from-orange-50 to-orange-100">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="text-gradient">Consommables</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Pensez à vos consommables pour vos tournages disponibles dans notre boutique
            </p>
          </div>
          
          <div className="text-center">
            <Link
              to="/catalogue-materiels?parent_category=consommable"
              className="inline-flex items-center px-8 py-4 bg-orange-600 text-white font-semibold rounded-xl hover:bg-orange-700 transition-colors duration-300 shadow-lg hover:shadow-xl"
            >
              <Package className="mr-3 h-5 w-5" />
              Voir nos consommables
            </Link>
          </div>
        </div>
      </section>

      {/* Nouvelle fonctionnalité - Listes favorites */}
      <section className="section-padding bg-gradient-to-br from-orange-50 to-orange-100">
        <div className="container-custom">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Contenu texte */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center mb-4">
                  <div className="bg-orange-100 px-3 py-1 rounded-full text-sm font-semibold mr-3" style={{ color: '#ff9a06' }}>
                    Nouveau
                  </div>
                  <Heart className="h-5 w-5" style={{ color: '#ff9a06' }} />
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
                  <span style={{ color: '#ff9a06' }}>Listes favorites</span> pour vos projets
                </h2>
                
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Créez des listes personnalisées de matériel pour organiser vos projets et accélérer vos demandes de réservation.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-start space-x-3">
                    <div className="bg-orange-100 rounded-full p-2 mt-1">
                      <Heart className="h-4 w-4" style={{ color: '#ff9a06' }} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Organisez vos équipements</h3>
                      <p className="text-gray-600 text-sm">Groupez le matériel par projet, type de tournage ou préférences</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <div className="bg-orange-100 rounded-full p-2 mt-1">
                      <Zap className="h-4 w-4" style={{ color: '#ff9a06' }} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Réservations rapides</h3>
                      <p className="text-gray-600 text-sm">Réservez tout le matériel d'une liste en un seul clic</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <div className="bg-orange-100 rounded-full p-2 mt-1">
                      <Clock className="h-4 w-4" style={{ color: '#ff9a06' }} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Gagnez du temps</h3>
                      <p className="text-gray-600 text-sm">Plus besoin de rechercher le même matériel à chaque projet</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/catalogue-materiels"
                    className="btn-primary text-center px-6 py-3 inline-flex items-center justify-center group"
                  >
                    Créer ma première liste
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                  <Link
                    to="/account/favorites"
                    className="btn-outline text-center px-6 py-3 inline-flex items-center justify-center group"
                  >
                    Voir mes listes
                    <Heart className="ml-2 h-4 w-4 group-hover:scale-110 transition-transform" />
                  </Link>
                </div>
              </div>
              
              {/* Image illustrative */}
              <div className="relative h-64 lg:h-auto overflow-hidden">
                <img 
                  src={backgroudImage}
                  alt="Matériel cinéma professionnel" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    console.log('Erreur chargement image:', e.target.src);
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                  onLoad={() => {
                    console.log('Image chargée avec succès');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-br from-orange-200 to-orange-300 flex items-center justify-center hidden">
                  <div className="text-center p-8">
                    <div className="w-32 h-32 bg-white/80 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                      <Heart className="h-16 w-16" style={{ color: '#ff9a06' }} />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Listes personnalisées</h3>
                    <p className="text-gray-600 text-sm">Organisez, sauvegardez, réservez</p>
                  </div>
                </div>
                
                {/* Overlay avec gradient pour améliorer la lisibilité */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section-padding bg-gradient-to-br from-orange-50 to-orange-100">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Pourquoi nous <span style={{ color: '#ff9a06' }}>choisir</span> ?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Des avantages qui font la différence pour vos projets
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={feature.title}
                className="text-center group"
              >
                <div className="w-20 h-20 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-orange-200 transition-colors">
                  <feature.icon className="h-10 w-10" style={{ color: '#ff9a06' }} />
                </div>
                <h3 className="text-2xl font-semibold mb-4 group-hover:text-gray-800 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 group-hover:text-gray-800 transition-colors">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Prêt à commencer votre <span className="text-gradient">projet</span> ?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Explorez notre catalogue et réservez votre matériel en quelques clics
          </p>
          <Link
            to="/catalogue-materiels"
            className="btn-primary text-lg px-8 py-4 inline-flex items-center justify-center group"
          >
            Commencer maintenant
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home
